import { atom } from 'jotai';

export const videoPreviewCurrentTimeAtom = atom(0);
